import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { routes } from 'routes/routes';
import type { CommunityTabItem } from 'features/communities-new';

export const useCommunityTabNavigation = (communityId: string) => {
  const navigate = useNavigate();

  const onNavigateToCommunityTab = useCallback(
    async (tab: CommunityTabItem) => {
      switch (tab) {
        case '/about':
          await navigate(routes.community.new.about(communityId));
          break;
        case '/assets':
          await navigate(routes.community.new.assets(communityId));
          break;
        case '/feed':
          await navigate(routes.community.new.feed(communityId));
          break;
      }
    },
    [communityId, navigate],
  );

  return { onNavigateToCommunityTab };
};
